import * as React from "react";
import renderUtils from "../../../helpers/renderUtils";
import {FormatTableActions} from "../FormatTableActions";
import {Badge} from "react-bootstrap";
import IconButton from "../../../components/button/IconButton";
import {useTranslation} from "react-i18next";


const columns = (onAdd, onMinus, showSat, t) => {

    return [
        {
            field: "id",
            label: t ? t("common.id") : "ID",
            sort: "desc",
            type: "badge",
            badgeType: "badge-primary",
            width: 53,
            // type:"badge"
        },
        {
            label: t ? t("common.name_and_dose") : "Nazwa i dawka",
            field: "nameAndDose",
            sort: "desc",
            width: 53,
        },
        {
            label: t ? t("common.introduction_date") : "Data wprowadzenia",
            field: "creationStartDate",
            sort: "desc",
            width: 53,
        },
        {
            label: t ? t("common.packing_line") : "Linia pakująca",
            field: "name",
            sort: "desc",
            width: 53,
            parent: "packingLine",
            type: "badge"
        },
        {
            label: t ? t("common.sat") : "SAT",
            field: "sat",
            sort: "desc",
            width: 53,
            type: "custom",
            custom: function (column, row, history, internalReload, setInternalReload, setLoader, disableRule, externalState) {
                const {sat} = row;

                return sat ?
                    <IconButton
                        tooltip={sat.ok ? t ? t("forms.positive_result") : "Pozytywny wynik" : t ? t("forms.negative_result") : "Negatywny wynik"}
                        variant={sat.ok ? "outline-primary" : "outline-danger"}
                        className={"btn-circle"}
                        icon={sat.ok ? "fa-check" : "fa-minus"}
                        onClick={() => showSat(sat)}
                    />
                    : <Badge className={"badge-warning-outline font-max"}></Badge>
            }
        },
        {
            label: t ? t("common.parts_count") : "Ilość części",
            field: "partsCount",
            sort: "desc",
            width: 53,
            type: "custom",
            custom: function (column, row, history, internalReload, setInternalReload, setLoader, disableRule, externalState) {
                return row.formatParts ?
                    <Badge className={"outline-secondary font-max"}>{row.formatParts?.length}</Badge> : ""
            }
        },
        {
            label: t ? t("common.status") : "Status",
            field: "formatStatus",
            sort: "desc",
            width: 53,
            type: "custom",
            custom: function (column, row, history, internalReload, setInternalReload, setLoader, disableRule, externalState) {
                return renderUtils.renderStatus(row.formatStatus, "", false, t)
            }
        },
        {
            field: "actions",
            label: t ? t("common.actions") : "Akcje",
            sort: "desc",
            width: 53,
            type: "custom",
            custom: function (column, row, history, reload, setReload, setLoader) {
                return <FormatTableActions
                    history={history}
                    onAdd={() => {
                        onAdd(row);
                    }}
                    onMinus={() => {
                        onMinus(row);
                    }}
                    onRemove={() => {
                        onMinus(row);
                    }}
                    row={row}
                    reload={reload}
                    setReload={setReload}
                    setLoader={setLoader}
                />
            }
        }


    ]
};

export default columns;